import Fee from './Fee.vue';

export default Fee;
